<cac-dialog-layout title="تاریخچه مکان" [hideControls]="true">
  <cac-table [options]="table"></cac-table>
</cac-dialog-layout>
